import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Panel } from 'react-bootstrap';

class CollapsePanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: props.defaultExpanded
    };
  }

  togglePanelExpanded = () => {
    this.setState(prevState => ({
      expanded: !prevState.expanded
    }));
  };

  render() {
    const { body, titleText } = this.props;
    return (
      <div onClick={this.togglePanelExpanded} role="menuitem" tabIndex="0">
        <Panel className="collapse-panel" defaultExpanded={this.state.expanded}>
          <Panel.Toggle className="collapse-panel-toggle">
            <Panel.Heading className={this.props.headingStyle}>
              <Panel.Title className="collapse-panel-title">
                {titleText}
                <i className="fa fa-chevron-down float-right" />
              </Panel.Title>
            </Panel.Heading>
          </Panel.Toggle>
          <Panel.Collapse>
            <Panel.Body className="text-black ">{body}</Panel.Body>
          </Panel.Collapse>
        </Panel>
      </div>
    );
  }
}

CollapsePanel.defaultProps = {
  defaultExpanded: false,
  headingStyle: 'bg-green-color'
};

CollapsePanel.propTypes = {
  titleText: PropTypes.string.isRequired,
  body: PropTypes.element.isRequired,
  defaultExpanded: PropTypes.bool,
  headingStyle: PropTypes.string
};

export default CollapsePanel;



// WEBPACK FOOTER //
// ./src/components/UtilComponents/CollapsePanel.js